import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import ScrapAgentService from '@/service/scrap-agent.service';
import type { IScrapAgent } from '@/shared/model/briefing-widget.model';
import { namespace } from 'vuex-class';

const briefingStore = namespace('briefingStore');

@Component({
  components: {},
})
export default class ModalStep3Component extends Vue {
  @Prop(Boolean) readonly open!: boolean;
  @Prop({ type: Object, default: () => ({}) }) itemCreateScrapAgent!: any;

  @briefingStore.Mutation
  public setSelectedScrapAgent!: (payload: IScrapAgent[]) => void;

  @Inject('scrapAgentService')
  public scrapAgentService!: () => ScrapAgentService;

  isLoading = 0;
  responseScrap = {} as any;

  @Watch('open', { immediate: true })
  async onOpenChange(newVal: boolean) {
    if (newVal) {
      this.isLoading = 0;
      try {
        let result;
        if (this.itemCreateScrapAgent.bpId) {
          result = await this.scrapAgentService().updateScrapAgent(this.itemCreateScrapAgent);
        } else {
          result = await this.scrapAgentService().addScrapAgent(this.itemCreateScrapAgent);
        }
        console.log(result.data, 'result');
        if (result) {
          if (result.data?.body?.status === 409 || result.data?.status === 409) {
            this.$bvToast.toast(result.data?.body?.message || result.data?.message, {
              toaster: 'b-toaster-bottom-right',
              title: `${this.$t('scrap-agent.toast.error')}`,
              variant: 'danger',
              solid: true,
              autoHideDelay: 5000,
            });
            this.isLoading = 2;
            return;
          }
          if (result.data?.body?.bpId == null) {
            this.responseScrap = result.data?.body?.body;
          } else {
            this.responseScrap = result.data?.body;
          }
          this.setSelectedScrapAgent(this.responseScrap);
          this.$bvToast.toast(`${this.$t('scrap-agent.toast.create-scrap.messSuccess')}`, {
            toaster: 'b-toaster-bottom-right',
            title: `${this.$t('scrap-agent.toast.success')}`,
            variant: 'success',
            solid: true,
            autoHideDelay: 5000,
          });
          console.log(this.responseScrap, 'responseScrap');

          setTimeout(() => {
            this.isLoading = 1;
          }, 500);
          this.$emit('markDoneCreateScrapAgent');
        }
      } catch (error) {
        const err = error.response?.data;
        const match = err?.detail?.match(/:\s*(\[\{.*\}\])/);

        if (err.status === 500) {
          if (match && match[1]) {
            try {
              const detailArray = JSON.parse(match[1]);
              const duplicateAgentError = detailArray.find(
                item => item.errorCode === 1001 && item.message && item.message.includes('Agent name already exists')
              );
              console.log(detailArray, 'detailArray');

              if (duplicateAgentError) {
                this.$bvToast.toast(`${this.$t('scrap-agent.home.duplicate-scrap')}`, {
                  toaster: 'b-toaster-bottom-right',
                  title: `${this.$t('scrap-agent.toast.error')}`,
                  variant: 'danger',
                  solid: true,
                  autoHideDelay: 5000,
                });
                this.isLoading = 2;
                return; // stop here
              }
            } catch (parseError) {
              console.error('Parse detail failed:', parseError);
            }
          }
        }

        if (err.status === 409) {
          // if (err.message.includes('storage limit exceeded')) {
          this.$bvToast.toast(err.message, {
            toaster: 'b-toaster-bottom-right',
            title: `${this.$t('scrap-agent.toast.error')}`,
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          });
          // } else {
          //   this.$bvToast.toast(`${this.$t('scrap-agent.toast.create-scrap.messFailStorageLimitToday')}`, {
          //     toaster: 'b-toaster-bottom-right',
          //     title: `${this.$t('scrap-agent.toast.error')}`,
          //     variant: 'danger',
          //     solid: true,
          //     autoHideDelay: 5000,
          //   });
          // }
        } else {
          this.$bvToast.toast(`${this.$t('scrap-agent.toast.create-scrap.messFail')}`, {
            toaster: 'b-toaster-bottom-right',
            title: `${this.$t('scrap-agent.toast.error')}`,
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          });
          setTimeout(() => {
            this.isLoading = 2;
          }, 500);
        }
      }
    }
  }

  async handleCloseModal() {
    if (this.isLoading === 1) {
      this.$emit('modal:back');
    } else {
      this.$emit('modal:close');
    }
    this.isLoading = 0;
  }

  async handleGoToAgent() {
    this.$emit('modal:close');
    this.isLoading = 0;
    if (this.itemCreateScrapAgent.bpId) {
      await this.$router.push(`/scrap-agent/${this.itemCreateScrapAgent.bpId}`);
    } else {
      if (this.responseScrap && (this.responseScrap as any).bpId) {
        await this.$router.push(`/scrap-agent/${(this.responseScrap as any).bpId}`);
      }
    }
  }

  titleModal() {
    if (this.itemCreateScrapAgent.bpId) {
      return 'scrap-create.setting-scrap-title';
    } else {
      return 'scrap-create.create-scrap-title';
    }
  }

  handleBackModal(isLoading: boolean) {
    if (isLoading) {
      if (this.itemCreateScrapAgent.bpId) {
        this.$emit('modal:close');
      } else {
        this.$emit('modal:back', isLoading);
      }
    } else {
      this.$emit('modal:back', false);
    }
    this.isLoading = 0;
  }
}
